const Dashboard = ({
  colorMode,
  totalTime,
  totalSavedTime,
  totalBooster,
  totalBreakTime,
}) => {
  const savedTime = totalSavedTime;
  const boosterTime = parseInt(parseFloat(totalBooster) * 150);
  const breakTime = totalBreakTime;

  const formatTime = (time, showSeconds = true) => {
    const hours = String(Math.floor(time / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((time % 3600) / 60)).padStart(2, "0");
    const seconds = String(time % 60).padStart(2, "0");
    return showSeconds
      ? `${hours}:${minutes}:${seconds}`
      : `${hours}:${minutes}`;
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          position: "relative",
          background: colorMode
            ? "linear-gradient(0deg, #e5fffa, #ffffff)"
            : "linear-gradient(135deg, #444, #666)",
          width: "290px",
          height: "80px",
          boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)",
          borderRadius: "16px",
          padding: "10px",
          color: colorMode ? "#333" : "#e0e0e0",
          marginBottom: "10px",
          marginTop: "10px",
        }}
      >
        {/* Title */}
        <h4
          style={{
            textAlign: "center",
            margin: "0",
            fontSize: "18px",
            fontWeight: "600",
            color: colorMode ? "#2c3e50" : "#ecf0f1", // Neutral, dark header color
            textShadow: "0px 1px 2px rgba(0, 0, 0, 0.2)",
          }}
        >
          Activity Summary
        </h4>

        <hr
          style={{
            border: "none",
            borderTop: "1px solid rgba(0, 0, 0, 0.1)",
            margin: "1px",
          }}
        />

        {/* Active Time */}
        <div
          style={{
            position: "absolute",
            top: "40px",
            left: "15px",
            textAlign: "left",
            fontSize: "14px",
          }}
        >
          <span
            style={{ fontWeight: "500", color: colorMode ? "#333" : "#ddd" }}
          >
            Active:
          </span>{" "}
          {formatTime(totalTime, false)}{" "}
          <span
            style={{ fontSize: "0.5rem", color: colorMode ? "#888" : "#bbb" }}
          >
            HH:MM
          </span>
        </div>

        {/* Saved Time */}
        <div
          style={{
            position: "absolute",
            top: "40px",
            right: "15px",
            textAlign: "right",
            fontSize: "14px",
          }}
        >
          <span
            style={{ fontWeight: "500", color: colorMode ? "#333" : "#ddd" }}
          >
            Saved:
          </span>{" "}
          {formatTime(savedTime, false)}{" "}
          <span
            style={{ fontSize: "0.5rem", color: colorMode ? "#888" : "#bbb" }}
          >
            HH:MM
          </span>
        </div>

        {/* Booster Time */}
        <div
          style={{
            position: "absolute",
            bottom: "15px",
            left: "15px",
            textAlign: "left",
            fontSize: "14px",
          }}
        >
          <span
            style={{ fontWeight: "500", color: colorMode ? "#333" : "#ddd" }}
          >
            Boost:
          </span>{" "}
          {formatTime(boosterTime, false)}{" "}
          <span
            style={{ fontSize: "0.5rem", color: colorMode ? "#888" : "#bbb" }}
          >
            HH:MM
          </span>
        </div>

        {/* Break Time */}
        <div
          style={{
            position: "absolute",
            bottom: "15px",
            right: "15px",
            textAlign: "right",
            fontSize: "14px",
          }}
        >
          <span
            style={{ fontWeight: "500", color: colorMode ? "#333" : "#ddd" }}
          >
            Break:
          </span>{" "}
          {formatTime(breakTime, false)}{" "}
          <span
            style={{ fontSize: "0.5rem", color: colorMode ? "#888" : "#bbb" }}
          >
            HH:MM
          </span>
        </div>
      </div>
    </div>
  );
};
export default Dashboard;
